import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignBlocksLeftSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 3H4v18h2V3zm2 3h13v5H8V6zm0 7h10v5H8v-5z" />
  </svg>
);
export default IconAlignBlocksLeftSizeM;
